import React from 'react';
import styles from './FeatureButton.module.css';
import { GlassButtonGroup } from '../CtaButton';

interface FeatureButtonProps {
  className?: string;
}

export const FeatureButton: React.FC<FeatureButtonProps> = ({ className = '' }) => {
  return (
    <div className={`${styles.featureContainer} ${className}`}>
      <GlassButtonGroup 
        discordLabel="Add to Discord"
        signUpLabel="Sign Up"
        discordHref="https://discord.com/oauth2/authorize?client_id=235088799074484224&permissions=8&integration_type=0&scope=bot"
        signUpHref="https://app.rythm.fm/"
      />
    </div>
  );
}; 